// Placeholder for GitLab FOSS
// Actual implementation: ee/app/assets/javascripts/notes/mixins/description_version_history.js
export default {
  computed: {
    canSeeDescriptionVersion() {},
    displayDeleteButton() {},
    shouldShowDescriptionVersion() {},
    descriptionVersionToggleIcon() {},
  },
  methods: {
    toggleDescriptionVersion() {},
    deleteDescriptionVersion() {},
  },
};
